import React from 'react';

import {Authorization} from '@appComponents/Authorization';
import {IconEdit} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {SPIIDEO_COMPETITOR_MAPPING} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ_UPDATE} from '@constants/variables';

const authorizationObject = {
    [SPIIDEO_COMPETITOR_MAPPING]: SECURITY_PRIVILEGES_READ_UPDATE,
};

const spiideoCompetitorMappingsTableRowRenderer = (column, row) => {
    switch (column) {
        case 'sport':
            return row.competitor?.sport?.name ?? '';
        case 'tournament_category':
            return row.competitor?.tournament_category?.name ?? '';
        case 'competitor':
            return row.competitor
                ? `${row.competitor.name} (${row.competitor.id})`
                : '';
        case 'spiideo_team_uuid':
            return row.spiideo_team_uuid ?? '';
        case 'sportradar_srt_url':
            return row.sportradar_srt_url ?? '';
        case 'ligr_srt_url':
            return row.ligr_srt_url ?? '';
        case 'actions':
            return (
                <Authorization authorization={authorizationObject}>
                    <div className='actions-list-icon'>
                        <IconEdit
                            size='large'
                            link={getLink('spiideoMappings.competitorEdit', {id: row.id})}
                            resource={SPIIDEO_COMPETITOR_MAPPING}
                        />
                    </div>
                </Authorization>
            );
        default:
            return null;
    }
};

export default spiideoCompetitorMappingsTableRowRenderer;
